import { render } from "./toDoItem.vue?vue&type=template&id=44e81f4e&scoped=true"
import script from "./toDoItem.vue?vue&type=script&lang=js"
export * from "./toDoItem.vue?vue&type=script&lang=js"

import "./toDoItem.vue?vue&type=style&index=0&id=44e81f4e&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44e81f4e"]])

export default __exports__